/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Desk_SubtitleInputs */

const en_admin_resources_desk_subtitle = /** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hot desk, fixed desk, workstation`)
};

const de_admin_resources_desk_subtitle = /** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexibler Schreibtisch, fester Schreibtisch, Arbeitsplatz`)
};

const es_admin_resources_desk_subtitle = /** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritorio flexible, escritorio fijo, puesto de trabajo`)
};

const fr_admin_resources_desk_subtitle = /** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau flexible, bureau fixe, poste de travail`)
};

const nl_admin_resources_desk_subtitle = /** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexplek, vaste plek, werkplek`)
};

/** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */
const it_admin_resources_desk_subtitle = en_admin_resources_desk_subtitle;

/** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_resources_desk_subtitle = en_admin_resources_desk_subtitle;

/** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */
const pl_admin_resources_desk_subtitle = en_admin_resources_desk_subtitle;

/** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */
const hu_admin_resources_desk_subtitle = en_admin_resources_desk_subtitle;

/** @type {(inputs: Admin_Resources_Desk_SubtitleInputs) => LocalizedString} */
const ro_admin_resources_desk_subtitle = en_admin_resources_desk_subtitle;

/**
* | output |
* | --- |
* | "Hot desk, fixed desk, workstation" |
*
* @param {Admin_Resources_Desk_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_desk_subtitle = /** @type {((inputs?: Admin_Resources_Desk_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Desk_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_desk_subtitle(inputs)
	if (locale === "de") return de_admin_resources_desk_subtitle(inputs)
	if (locale === "es") return es_admin_resources_desk_subtitle(inputs)
	if (locale === "fr") return fr_admin_resources_desk_subtitle(inputs)
	if (locale === "nl") return nl_admin_resources_desk_subtitle(inputs)
	if (locale === "it") return it_admin_resources_desk_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_desk_subtitle(inputs)
	if (locale === "pl") return pl_admin_resources_desk_subtitle(inputs)
	if (locale === "hu") return hu_admin_resources_desk_subtitle(inputs)
	return ro_admin_resources_desk_subtitle(inputs)
});
export { admin_resources_desk_subtitle as "admin.resources.desk_subtitle" }